module.exports = __webpack_public_path__ + "img/Logo.23f95b24.jpg";